import { z } from "zod/v4";

/**
 * Available status values for an annual statement.
 * - started: Initial state when annual statement is created
 * - documentsProvided: Documents have been uploaded/provided
 * - prepared: Annual statement has been prepared
 * - underTaxAdvisorReview: Annual statement is being reviewed by tax advisor
 * - reviewed: Tax advisor review is complete, ready for signing
 * - signed: Annual statement has been signed
 * - disclosed: Annual statement has been publicly disclosed
 */
export const annualStatementStatusValues = [
  "started",
  "documentsProvided",
  "prepared",
  "underTaxAdvisorReview",
  "reviewed",
  "signed",
  "disclosed",
] as const;

export const annualStatementStatusSchema = z.enum(annualStatementStatusValues);
export type AnnualStatementStatus = z.infer<typeof annualStatementStatusSchema>;

/**
 * Schema for AnnualStatement entity
 *
 * Represents an annual statement for a company in a specific year.
 * Uses a composite primary key of (companyId, year).
 */
export const annualStatementSchema = z.object({
  companyId: z.string(),
  year: z
    .number()
    .int()
    .min(2019, { message: "Das Jahr muss 2019 oder später sein." }),
  status: annualStatementStatusSchema.default("started"),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type AnnualStatement = z.infer<typeof annualStatementSchema>;
